const communicationDepartments = {

    init: function() {
        this.setupReadMoreFunctionality();
    },

    setupReadMoreFunctionality: function() {
        const readMoreButton = document.getElementById('show-more-departments');
        if ( ! readMoreButton ) {
            return;
        }

        const self = this;
        readMoreButton.addEventListener('click', function(event) {
            event.preventDefault();
            self.showHiddenDepartments();
            self.hideReadMoreButton(readMoreButton);
        });
    },

    showHiddenDepartments: function() {
        const hiddenGroups = document.querySelectorAll('.letter-group--hidden');

        hiddenGroups.forEach(function(group) {
            group.classList.remove('letter-group--hidden');
            group.classList.add('letter-group--show');
        });
    },

    hideReadMoreButton: function(button) {
        const buttonContainer = button.closest('.communication-read-more');
        if (buttonContainer) {
            buttonContainer.style.display = 'none';
        }
    }
};

export default communicationDepartments;